export default {"src":"/_next/static/media/BTE.85e68d1f.svg","height":18,"width":18};